export default function NoJavascript() {
  return (
    <noscript>
      <div class="flex flex-col gap-5 text-text p-10 text-center ">
        In order to view this page correctly, you must have a JavaScript-enabled
        browser and have JavaScript turned on. We apologize for any
        inconvenience.{' '}
        <a
          href="//support.google.com/adsense/bin/answer.py?hl=en&amp;answer=12654"
          target="_blank"
          className="text-blue-600 underline"
        >
          Learn how to enable it
        </a>
      </div>
    </noscript>
  )
}
